function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
const SvgIconMarker = props => {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 20",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7 0C5.13 0 3.37.73 2.05 2.05-.39 4.5-.7 9.11 1.4 11.9L7 20l5.6-8.09c2.1-2.8 1.79-7.41-.65-9.86A6.96 6.96 0 007 0zM4.51 6.94c0-1.41 1.15-2.56 2.56-2.56 1.4 0 2.55 1.15 2.55 2.56 0 1.41-1.15 2.56-2.55 2.56-1.41 0-2.56-1.15-2.56-2.56z"
  }));
};
SvgIconMarker.propTypes = process.env.NODE_ENV !== "production" ? {
  title: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  fill: PropTypes.string,
  label: PropTypes.string
} : {};
export default SvgIconMarker;